import React from 'react';
import './WeaponTypeFilter.css';
import DropdownMenu from './DropdownMenu';
import MediaImg from './MediaImg';
import TypeFilterGroup from './TypeFilterGroup';
import { CAT, GROUPED_TYPES, WEAPON_GROUP_IMG } from '../../core/buildUtils';

/**
 * Which weapon types the search may equip, behind one control.
 *
 * Eleven icons is too many to spread along a row, so they live in a dropdown
 * that says how many are on. Shown in both places that filter: the advanced
 * settings, and the weapon row of the spells panel. The setting itself is
 * `genConfig.typeFilters` either way — the caller owns it, this only toggles.
 */
const TXT_WEAPON_TYPES = {
    fr: "Types d'armes",
    en: 'Weapon types',
    de: 'Waffenarten',
    es: 'Tipos de armas',
    pt: 'Tipos de armas',
};

const WEAPON_TYPES = GROUPED_TYPES[CAT.WEAPON] || [];

const WeaponTypeFilter = ({
    typeFilters = {},
    onToggleType,
    lang = 'fr',
    disabled = false,
}) => {
    const types = WEAPON_TYPES;
    // "5/11" rather than a tick: the number is what the user wants to know
    // without opening it, and it says at a glance that some are off.
    const onCount = types.filter((t) => typeFilters[t.id]).length;

    if (!types.length) return null;

    const label = TXT_WEAPON_TYPES[lang] || TXT_WEAPON_TYPES.en;

    return (
        // With none of them on, the control greys out the way a single type
        // icon does when it is off — the weapons are excluded from the search
        // either way, and the row says so in one language.
        <div className={`weapon-type-filter${onCount === 0 ? ' weapon-type-filter--off' : ''}`}>
            <DropdownMenu
                disabled={disabled}
                dropdownClassName="weapon-type-filter-dropdown"
                menuClassName="weapon-type-filter-menu"
                buttonTooltip={label}
                buttonContent={(
                    // The icon and the count carry it; what it is called is in
                    // the tooltip, where a name nobody needs twice belongs.
                    <>
                        <MediaImg
                            src={WEAPON_GROUP_IMG}
                            className="weapon-type-filter-icon"
                            alt={label}
                            fallback=""
                        />
                        <span className="weapon-type-filter-count">
                            {onCount}/{types.length}
                        </span>
                    </>
                )}
            >
                <TypeFilterGroup
                    types={types}
                    typeFilters={typeFilters}
                    onToggleTypeFilter={onToggleType}
                    lang={lang}
                    wrap
                />
            </DropdownMenu>
        </div>
    );
};

export default WeaponTypeFilter;
